'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleGroup, ToggleGroupItem } from './ui/toggle-group';
export function Choice({ value, options, onChange, label, className, size = 'default', ...rest }) {
    return (_jsx(ToggleGroup, { type: "single", value: value, "aria-label": label, spacing: 0, size: size, "data-choice": true, className: `bg-muted rounded-lg p-1 ${className ?? ''}`, onValueChange: (next) => {
            /* Повторное нажатие по выбранному даёт пустую строку: значение
               обязано остаться - у набора вариантов нет состояния «ничего». */
            if (next !== '')
                onChange(next);
        }, ...rest, children: options.map((option) => (_jsx(ToggleGroupItem, { value: option.value, disabled: option.disabled, title: option.title, ...option.data, 
            /* Невыбранное - `foreground/80`, а не `muted-foreground`:
               серый по серому давал 4,13:1 на 12,8 px и не проходил AA
               (ворота доступности правой колонки). Выбранное отличается
               подложкой, тенью и полным цветом текста сразу. */
            className: "text-foreground/80 data-[state=on]:bg-background data-[state=on]:text-foreground rounded-md data-[state=on]:shadow-sm", children: option.label }, option.value))) }));
}
//# sourceMappingURL=Choice.js.map